import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { SCHero } from '../components/sculptra/SCHero';
import { SCWhatIs } from '../components/sculptra/SCWhatIs';
import { SCHowItWorks } from '../components/sculptra/SCHowItWorks';
import { SCWhereUsed } from '../components/sculptra/SCWhereUsed';
import { SCFAQ } from '../components/sculptra/SCFAQ';
import { SCWhyChoose } from '../components/sculptra/SCWhyChoose';
export function SculptraPage() {
  return <div className="min-h-screen w-full bg-black font-body" style={{
    scrollBehavior: 'smooth'
  }} data-id="element-2610">
      <Navigation data-id="element-2611" />
      <main data-id="element-2612">
        <SCHero data-id="element-2613" />
        <SCWhatIs data-id="element-2614" />
        <SCHowItWorks data-id="element-2615" />
        <SCWhereUsed data-id="element-2616" />
        <SCFAQ data-id="element-2617" />
        <SCWhyChoose data-id="element-2618" />
      </main>
      <Footer data-id="element-2619" />
    </div>;
}